import { useUnlockBankAccount } from '@/hooks/requests/useBankAccounts';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
} from '@mui/material';
import { SVButton } from '../../core';
import { MESSAGES } from '@/constants/messages';
import showToast from '@/utils/toast';

type BankAccountUnlockModalProps = {
  bankAccountId: string;
  accountNumberLast4: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function BankAccountUnlockModal({
  bankAccountId,
  accountNumberLast4,
  open,
  setOpen,
}: BankAccountUnlockModalProps) {
  const { unlockBankAccount, isUnlockBankAccountPending } =
    useUnlockBankAccount(bankAccountId);

  async function handleUnlockBankAccount() {
    try {
      await unlockBankAccount();
      showToast({
        type: 'success',
        data: { content: 'Bank account has been successfully unlocked' },
      });
      setOpen(false);
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Typography variant="h4">Unlock Bank Account?</Typography>
        <Typography>
          Are you sure you would like to unlock the bank account with account
          number ending in: [****{accountNumberLast4}]?
        </Typography>
      </DialogContent>
      <DialogActions>
        <SVButton variant="outlined" onClick={() => setOpen(false)}>
          No, Don't Unlock
        </SVButton>
        <SVButton
          isLoading={isUnlockBankAccountPending}
          onClick={handleUnlockBankAccount}>
          Yes, Unlock
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
